import { Outlet } from "react-router-dom";

export default function PharmacistLayout() {
  return (
    <div>
      
      <Outlet />
    </div>
  );
}
